import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { DialogVideosComponent } from '@pages/help/dialog-videos/dialog-videos.component';
import {AdfiService} from '@services/adfi-service';
import { PeriodState } from '@Interfaces/index';

@Component({
  selector: 'app-trainings-videos',
  templateUrl: './trainings-videos.component.html',
  styleUrls: ['./trainings-videos.component.scss']
})
export class TrainingsVideosComponent implements OnInit {

  sections: any[];
  isHiddenStates: { [key: string]: boolean } = {}
  block : boolean;

  constructor(private dialog: MatDialog, private graphql: AdfiGraphqlService, private service: AdfiService) { }

  ngOnInit(): void {
    this.loadSections();
    this.block = this.service.validPermission('BlockingPlatform', 'lock', PeriodState.NO_STATUS); 
  }

  private async loadSections() {
    const params = 'active: true';
    const all = await this.graphql.countEntity('manualModules', params);
    this.graphql.getEntity('manualModules', 'label moduleKey image trainingVideos { edges { node { _id label imageKey videoKey presentationKey new} } }', all, params, {
      next: (d) => {
        this.sections = d;
        this.isHiddenStates[d.moduleKey] = false;
      }
    }, null, null, (item) => {
      if (item && item.trainingVideos && item.trainingVideos.edges) {
        item.trainingVideos = item.trainingVideos.edges.map(n => n.node);
      } else {
        item.trainingVideos = [];
      }
      return item;
    }
    );
  }

  openViewVideo(video) {
    const dialogRef = this.dialog.open(DialogSelectVideoComponent, {
      width: '40%',
      data: { title: video.label, video }
    });

    dialogRef.afterClosed().subscribe(choice => {
      if (!choice) {
        return;
      }
      if (choice === 'play') {
        this.dialog.open(DialogVideosComponent, {
          width: '67%',
          height: '80vh',
          data: { title: video.label, idVideo: video?.videoKey }
        });
      } else if (choice === 'drive') {
        const id = video?.presentationKey;
        if (id) {
          const url = `https://drive.google.com/file/d/${id}/view`;
          window.open(url, '_blank');
        }
      }
    });
  }

  hiddeContent(section: any): void {
    const element = document.getElementById(section.moduleKey);
    const isHidden = element.classList.toggle('hidden');
    this.isHiddenStates[section.moduleKey] = isHidden;
  }

}

@Component({
  selector: 'app-dialog-select-video',
  templateUrl: './dialog-select-video.component.html',
  styleUrls: ['./dialog-select-video.component.scss']
})
export class DialogSelectVideoComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogSelectVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; video: any }
  ) { }

  select(option: 'play' | 'drive') {
    this.dialogRef.close(option);
  }

  close() {
    this.dialogRef.close();
  }
}